import { JSONContent } from '@tiptap/core';
import { CustomSectionType } from 'api/custom-section/types';

export const VERSION_HISTORY_SECTION_TYPES: CustomSectionType[] = [
  CustomSectionType.Question,
  CustomSectionType.Action,
  CustomSectionType.ExtractInfo,
  CustomSectionType.QuestionAnswerItem,
  CustomSectionType.TableDetails,
  CustomSectionType.RecordBlock,
];

export const isVersionHistorySectionType = (
  sectionType?: string,
  nodeType?: string,
): boolean =>
  VERSION_HISTORY_SECTION_TYPES.includes(sectionType as CustomSectionType) ||
  VERSION_HISTORY_SECTION_TYPES.includes(nodeType as CustomSectionType);

export const isTableOrRecordSection = (
  sectionType?: string,
  nodeType?: string,
): boolean =>
  sectionType === CustomSectionType.TableDetails ||
  sectionType === CustomSectionType.RecordBlock ||
  nodeType === CustomSectionType.TableDetails ||
  nodeType === CustomSectionType.RecordBlock;

/** Find the first table node in doc content or return the node if it is a table. */
export function findTableNode(
  content: JSONContent | JSONContent[],
): JSONContent | null {
  if (Array.isArray(content)) {
    for (const node of content) {
      const found = findTableNode(node);

      if (found) {
        return found;
      }
    }

    return null;
  }
  if (content?.type === 'table') {
    return content;
  }
  if (Array.isArray(content?.content)) {
    return findTableNode(content.content);
  }

  return null;
}

/**
 * Collapsed TABLE/RECORD preview: header row + first data row (one record).
 */
export function sliceTableToFirstRecord(
  tableNode: JSONContent,
): JSONContent | null {
  const rows = tableNode.content;

  if (!Array.isArray(rows) || rows.length === 0) {
    return null;
  }

  return {
    ...tableNode,
    content: rows.slice(0, Math.min(2, rows.length)),
  };
}

/** Table JSON to render in the version card. Preview keeps header + one record. */
export function getTableVersionContent(
  content: JSONContent,
  preview: boolean,
): JSONContent[] | undefined {
  const table = findTableNode(
    content?.type === 'doc' ? (content.content ?? []) : content,
  );

  if (!table) {
    return undefined;
  }

  if (!preview) {
    return [table];
  }

  const sliced = sliceTableToFirstRecord(table);

  return [sliced ?? table];
}
